import { useState } from "react";
import { useSelector } from "react-redux";
import Header from "../Header";
import Sidebar from "../Sidebar";

const Nav = () => {
  const [active, setActive] = useState(
    JSON.parse(localStorage.getItem("active_nav"))
  );
  const [menuClick, setMenuClick] = useState(false);
  const { title, breadcrumbs } = useSelector((state) => state?.topMenu);

  return (
    <>
      <Header
        active={active}
        setMenuClick={setMenuClick}
        menuClick={menuClick}
        breadcrumbs={breadcrumbs}
        title={title}
      />

      <Sidebar
        menuClick={menuClick}
        active={active}
        setActive={setActive}
        setMenuClick={setMenuClick}
      />
    </>
  );
};

export default Nav;
